import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Subscription } from "@appTypes/index";
import SubscriptionLogo from "@components/Subscriptions/SubscriptionLogo";
import { getProductDurationLabel } from "@utils/getSubscriptionDisplayInformation";

interface SubscriptionInfoProps {
  subscription: Subscription;
  className?: string;
}

const SubscriptionInfo = ({ subscription, className }: SubscriptionInfoProps) => {
  const { t } = useTranslation();
  return (
    <div className={`flex items-center gap-3${className ? ` ${className}` : ""}`}>
      <SubscriptionLogo logoType="tp" />
      <div>
        {subscription.recurringIntervalCount != null && subscription.recurringInterval != null && (
          <Typography variant="h6" className="font-bold text-xs">
            {t(getProductDurationLabel(subscription.recurringIntervalCount, subscription.recurringInterval))}
          </Typography>
        )}
        <Typography variant="h6" className="font-bold">
          {subscription.productName}
        </Typography>
      </div>
    </div>
  );
};

export default SubscriptionInfo;
